module.exports = __webpack_public_path__ + "img/registre-lazy.47594ef1.jpg";